import actions from "../../constants/actions";

export const login = (email, password) => {
    return {
        type: actions.LOGIN,
        payload: {
            email,
            password,
        },
    };
};

export const register = (data) => {
    return {
        type: actions.REGISTER,
        payload: {
            data,
        },
    };
};

export const recover = (email) => {
    return {
        type: actions.RECOVER,
        payload: {
            email,
        },
    };
};

export const reset = (email = null, password = null, token = null) => {
    return {
        type: actions.RESET,
        payload: {
            email,
            password,
            token,
        },
    };
};

export const logout = () => {
    return {
        type: actions.LOGOUT,
    };
};
